import React from "react";
import { Rocket, ArrowDown } from "lucide-react";

const Hero = () => {
  const scrollToNext = () => {
    const element = document.getElementById("about");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-icon">
            <Rocket className="rocket-icon" />
          </div>
          <h1 className="hero-headline">
            DoubleTap Innovations & Technologies Pvt. Ltd.
          </h1>
          <p className="hero-subheadline">
            Empowering businesses through cutting-edge innovation and intelligent technology solutions.
          </p>
          <div className="hero-cta">
            <p className="cta-text">Launching Soon – Stay Tuned!</p>
            <p className="cta-subtext">Sign up to get early updates and exclusive launch offers.</p>
            <button onClick={() => document.getElementById("launching").scrollIntoView({ behavior: "smooth" })} className="cta-button">
              Join the Waitlist
            </button>
          </div>
        </div>
        <div className="scroll-indicator" onClick={scrollToNext}>
          <ArrowDown className="scroll-arrow" />
        </div>
      </div>
    </section>
  );
};

export default Hero;